module.exports = "HELLO WORLD"


//////////////////
// WEBPACK FOOTER
// C:/projects/angular/DineroAgil/src/app/pages/home/home.component.html
// module id = ../../../../../src/app/pages/home/home.component.html
// module chunks = main